import { styled as t } from "styled-components";
import { ZIndex as i } from "../../styles/variables.js";
const r = t.div`
  position: fixed;
  top: ${({ $topPosition: e }) => typeof e < "u" ? `${e}px` : "inherit"};
  bottom: ${({ $bottomPosition: e }) => typeof e < "u" ? `${e}px` : "inherit"};
  width: 100%;
  left: 0;
  right: 0;
  z-index: ${i.TOAST};
`;
export {
  r as ToastContainer
};
